import { ShowGame } from "./components/ShowGame";

export default ShowGame;
